import(/* webpackMode: "eager" */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/(alfamall)/b2b-payments/page.jsx");
